// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/202608190959/js/" + chunkId + "." + {"44":"016ac657","225":"c48b5133","481":"2c5bfc7b","486":"8498c168","770":"759af54d"}[chunkId] + ".0.5534492562130731.chunk.js";
};